import React, {Component} from 'react';
import _size from 'lodash/size';
import {Helmet} from 'react-helmet';

class MetaTags extends Component {

    render() {
        const {title, tags, metaDescriptions, og_title, og_description, isPlaces} = this.props;
        return (
            <Helmet>
                {og_title && !isPlaces && <meta property="og:title" content={og_title} data-react-helmet="false"/>}
                {og_description && !isPlaces  && <meta property="og:description" content={og_description} data-react-helmet="false"/>}
                {title && !isPlaces && <title>{title}</title>}
                {metaDescriptions && !isPlaces && <meta name="description" content={metaDescriptions}/>}
                {_size(tags) && !isPlaces && <meta name="keywords" content={tags.join(',')}/>}
            </Helmet>
        )
    }
}

export default MetaTags;
